import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';

const ErrorContent = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <Illustration className="size-40" component="IllustrationLocalError" />

      <h4 className={typographyVariants({ variant: 'h4' })}>
        {t('Loading error')}
      </h4>
      <p
        className={typographyVariants({
          variant: 'bodyShort01',
          color: 'secondary',
          className: 'mt-2',
        })}
      >
        {t('Please check your connection and try again.')}
      </p>
    </div>
  );
};

export default ErrorContent;
